import { loadable } from "@marta/utils";

export const NavigationContainer = loadable(
  () => import("./navigation-container"),
);
